import type { DateSeries } from '@/api/types';
import { DAYS_LONG, clockLabel } from '@/features/links/links';

/** v9 §A5 weekly date night: wording. */

/** "Every Thursday, 9 pm" — in the series' own timezone (what both agreed on). */
export function seriesLabel(s: Pick<DateSeries, 'weekday' | 'time'>): string {
  return `Every ${DAYS_LONG[s.weekday] ?? 'week'}, ${clockLabel(s.time)}`;
}

export const SERIES_STATUS: Record<DateSeries['status'], string> = {
  pending: 'Waiting for a yes',
  active: 'On',
  paused: 'Paused',
  declined: 'Declined',
  stopped: 'Stopped',
};

/** "Next: Thu 22 Oct, 9:00 PM" in the viewer's zone. */
export function nextLabel(s: Pick<DateSeries, 'next_at'>): string | null {
  if (!s.next_at) return null;
  const d = new Date(s.next_at);
  return `Next: ${d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' })}, ${d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}`;
}

/** Time options for the weekly picker: every 30 minutes from 7 am to 11:30 pm. */
export function seriesTimes(): string[] {
  const out: string[] = [];
  for (let m = 7 * 60; m < 24 * 60; m += 30) out.push(`${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`);
  return out;
}
